import app from 'flarum/forum/app';
import MentionableModel from './MentionableModel';
import usernameHelper from 'flarum/common/helpers/username';
import Avatar from 'flarum/common/components/Avatar';
import highlight from 'flarum/common/helpers/highlight';
import { truncate } from 'flarum/common/utils/string';
import getCleanDisplayName from '../utils/getCleanDisplayName';
export default class PostMention extends MentionableModel {
  type() {
    return 'post';
  }

  /**
   * If the user is replying to a discussion, or if they are editing a
   * post, then we can suggest other posts in the discussion to mention.
   * We will add the 5 most recent comments in the discussion which
   * match any username characters that have been typed.
   */
  initialResults() {
    if (!app.composer.bodyMatches('flarum/forum/components/ReplyComposer') && !app.composer.bodyMatches('flarum/forum/components/EditPostComposer')) {
      return [];
    }

    // @ts-ignore
    const composerAttrs = app.composer.body.attrs;
    const composerPost = composerAttrs.post;
    const discussion = composerPost && composerPost.discussion() || composerAttrs.discussion;
    return discussion.posts()
    // Filter to only comment posts, and replies before this message
    .filter(post => post && post.contentType() === 'comment' && (!composerPost || post.number() < composerPost.number()))
    // Sort by new to old
    .sort((a, b) => b.createdAt().getTime() - a.createdAt().getTime());
  }

  /**
   * Generates the syntax for mentioning of a post. Also cleans up the display name.
   *
   * @example <caption>Post mention</caption>
   * // '@"User"#p13'
   * // @"Display name"#pPostID
   * forPostMention(user, 13) // User display name is 'User', post ID is 13
   */
  replacement(post) {
    const user = post.user();
    const cleanText = getCleanDisplayName(user);
    return this.format.format(cleanText, 'p', post.id());
  }
  suggestion(model, typed) {
    var _model$contentPlain;
    const user = model.user() || null;
    const username = usernameHelper(user, name => highlight(name, typed));
    return m('[', null, m(Avatar, {
      user: user
    }), username, [app.translator.trans('flarum-mentions.forum.composer.reply_to_post_text', {
      number: model.number()
    }), ' — ', truncate((_model$contentPlain = model.contentPlain()) != null ? _model$contentPlain : '', 200)]);
  }
  matches(model, typed) {
    const user = model.user();
    const userMentionable = app.mentionFormats.mentionable('user');
    return !typed || user && userMentionable.matches(user, typed);
  }
  maxStoreMatchedResults() {
    return 5;
  }

  /**
   * Post mention suggestions are only offered from current discussion posts.
   */
  search(typed) {
    return Promise.resolve([]);
  }
  enabled() {
    return true;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/PostMention', PostMention);